import type { TFunction, i18n as i18nNext } from 'i18next';
import { useTranslation as useI18NextTranslation } from 'react-i18next';

export type { TFunction } from 'i18next';

export function useTranslation(): {
  t: TFunction;
  i18n: i18nNext;
} {
  const { t, i18n } = useI18NextTranslation();

  return { t, i18n };
}
